export const BulletinsDashboardContainerComponent = {
    template: `
        <apex-bulletins-dashboard ng-if="$ctrl.loaded && $ctrl.bulletins.length"
                                  messages="$ctrl.bulletins"
                                  acknowledge-bulletin="$ctrl.onAcknowledgeBulletin($event)"
                                  acknowledge-all-bulletins="$ctrl.onAcknowledgeAllBulletins($event)">
        </apex-bulletins-dashboard>`,
    require: {
        dashboardContext: "?^apexDashboardContent"
    },
    controller: class BulletinsDashboardContainer {
        constructor($q, messageService, utilityService) {
            'ngInject'
            this.$q = $q
            this.messageService = messageService
            this.utilityService = utilityService
            this.loaded = false
        }

        $onInit() {
            // TODO: Server paging to prevent increasing bulletin
            // download time for users who never acknowledge bulletins.
            this.messageService.retrieveBulletinInbox()
                .then(bulletins => {
                    this.bulletins = bulletins
                    this.loaded = true

                    if (this.dashboardContext) {
                        this.dashboardContext.activateDashboard({
                            visible: true,
                            count: bulletins.length,
                            acknowledgeAll: sendEmailCopy => {
                                this.onAcknowledgeAllBulletins({
                                    bulletins: bulletins,
                                    sendEmailCopy: sendEmailCopy
                                })
                            }
                        })
                    }
                })
        }

        onAcknowledgeBulletin({ bulletin, sendEmailCopy }) {
            this.setBulletinAcknowledged(bulletin, sendEmailCopy)
                .catch(function (ex) {
                    alert("Acknowledgment failed: " + (ex.statusText || ex));
                })
        }

        onAcknowledgeAllBulletins({ bulletins, sendEmailCopy }) {
            const acknowledgeEach = bulletins.filter(bulletin => !bulletin.IsAcknowledged)
                .map(bulletin => this.setBulletinAcknowledged(bulletin, sendEmailCopy));
            this.$q.all(acknowledgeEach)
                .catch((ex) => {
                    console.error(ex)
                    alert("Acknowledgment failed: " + this.utilityService.getExceptionMessage(ex));
                });
        }

        setBulletinAcknowledged(bulletin, sendEmailCopy) {
            bulletin.IsAcknowledged = true;
            return this.messageService
                .acknowledgeBulletin(bulletin.BulletinID, sendEmailCopy)
                .catch(function (ex) {
                    bulletin.IsAcknowledged = false;
                    throw ex;
                });
        }
    }
}
